import { JsonSchema } from 'lib/json-schema';

export interface LayoutVariableDefinitionBase {
  key: string;
  type: LayoutVariableDefinitionType;
  json_schema: JsonSchema;
  transform_results: string | null;
}

export interface ObjectQueryVariableDefinition extends LayoutVariableDefinitionBase {
  type: LayoutVariableDefinitionType.ObjectQuery;
  method_chain: string;
}

export interface StaticVariableDefinition extends LayoutVariableDefinitionBase {
  type: LayoutVariableDefinitionType.Static;
  value: string;
}

export interface SnowflakeQueryVariableDefinition extends LayoutVariableDefinitionBase {
  type: LayoutVariableDefinitionType.SnowflakeQuery;
  datasource_id: string;
  sql: string;
}

export enum LayoutVariableDefinitionType {
  ObjectQuery = 'object_query',
  Static = 'static',
  SnowflakeQuery = 'snowflake_query',
}

export const LayoutVariableDefinitionTypeToLabel: Record<LayoutVariableDefinitionType, string> = {
  [LayoutVariableDefinitionType.ObjectQuery]: 'Persona Database',
  [LayoutVariableDefinitionType.SnowflakeQuery]: 'Snowflake',
  [LayoutVariableDefinitionType.Static]: 'Constant',
};

export type LayoutVariableDefinition =
  | ObjectQueryVariableDefinition
  | StaticVariableDefinition
  | SnowflakeQueryVariableDefinition;
